import { mmFetch } from './mmFetch';
import { mmFetchWithResponse } from './mmFetchWithResponse';

const giftCodeApi = {
    createCodes: async (formData) => {
        const url = `api/giftCodes/v1/system/batches`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(formData),
        });
    },
    downloadCodes: async (id) => {
        const filename = `gift_codes_batch_${id}.csv`;
        const url = `api/giftCodes/v1/system/batches/${id}/csv`;
        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                const blob = await res.blob();
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob);
                    return;
                }

                const d = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                document.body.appendChild(link);
                link.href = d;
                link.download = filename;
                link.click();

                setTimeout(() => {
                    if (window.URL && typeof window.URL.revokeObjectURL === 'function') {
                        window.URL.revokeObjectURL(res);
                    }
                }, 200);
            }
        } catch (e) {
            console.log('[downloadCodes] error', e.toString());
        }
    },
    getSystemCodeBatches: async () => {
        const url = `api/giftCodes/v1/system/batches`;
        return mmFetchWithResponse(url);
    },
};

export { giftCodeApi };
